module.exports = __webpack_public_path__ + "static/media/desktop-instruction.5cd34407.jpg";